import {BaseSearchableService} from "./Core/BaseSearchableService";
import {service as ContextNodeService} from "./ContextNodeService";

class ConservationActionService extends BaseSearchableService {
    get Url() { return super.Url + "/conservationActions"; }
    get ModelName() { return "Conservation Action"; }
    get PrimaryKeyProperty() { return "conservationActionId"; }

	GetTitle(model, defaultTitle = "") {
        return model?.ContextNodeDetails?.name ?? defaultTitle;
    }

    GetConservationActionsForProjectId(projectId) {
        let request = {projectId: projectId};

        return this.SendRequest(BaseSearchableService.GET, request);
    }
    
    GetSearchableString(model) {
        return [
            super.GetSearchableString(model),
            ContextNodeService.GetSearchableString(model?.ContextNodeDetails ?? null),
        ].filter(Boolean).join(" ");
    }
}

export const service = new ConservationActionService();

